const StoryCollection = [
  {
    title: ' Great Team!',
    description: ' They deliver what is promised with no hidden charges. Their process is transparent',
    img_src: 'https://res.cloudinary.com/dnl5kwhe6/image/upload/v1567563419/Quick_Credit/nat-9_dzc3vp.jpg',
    author: 'Adeola Sarafina',
  },
  {
    title: 'Application is so easy',
    description: 'I love this application. It is so easy to register and it helps out when I am in dire need of finances',
    img_src: 'https://res.cloudinary.com/dnl5kwhe6/image/upload/v1567563418/Quick_Credit/nat-8_ziap9u.jpg',
    author: 'Ciroma Ahmed',
  },
];

export default StoryCollection;
